
const formatDecimal = function (value, minimumFractionDigits = 0) {
  const formatter = new Intl.NumberFormat('de-DE', { minimumFractionDigits })
  return formatter.format(value)
}

export default {
  methods: {
    formatDecimal
  }
}
